import { render, staticRenderFns } from "./TitleLogin.vue?vue&type=template&id=864635ec&"
import script from "./TitleLogin.vue?vue&type=script&lang=js&"
export * from "./TitleLogin.vue?vue&type=script&lang=js&"
import style0 from "./TitleLogin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports